export default __webpack_public_path__ + "static/media/151-mail.f24ec925.png";